export default __webpack_public_path__ + "static/media/Imagen_fondocanales.ecceb18a.png";